/*
  utils/Api

  Contains request configuration and execution methods
 */

 const api_host = 'https://api.sniffers.co.nz/api';
 
 const CONTENT_AS_FORMDATA = true;
 const REQUEST_TIMEOUT = 600000; // 10 minutes

 export const TOP_LEVEL_DOMAIN = api_host.replace('/api/v1', '');
 export const API_HOST = api_host;
 export const AUTH_HEADER = "Authorization";

/*
  Basic usage:

    request('auth/token', 'POST', {
      email: 'oliver.shaw@littlegiant.co.nz',
      password: 'password'
    });
*/
export const request = (endpoint, method = 'GET', body = {}, headers = null, allow_body_mutation = true) => {
  // Merge default headers with request headers
  let requestHeaders = Object.assign({}, {}, headers);

  if(method == 'GET' && body !== null) {
    endpoint = `${endpoint}?${encodeQueryData(body)}`;
    body = undefined;
  } else if(allow_body_mutation) {
    // Convert body to acceptable type
    if(typeof body === 'object' && CONTENT_AS_FORMDATA && method !== 'PATCH') {
      // Convert object to FormData
      let formData = new FormData();
      for(var key in body) {
        formData.append(key, body[key]);
      }

      body = formData;
    } else if(CONTENT_AS_FORMDATA && method === 'PATCH') {
      requestHeaders = Object.assign({}, {
          'Content-Type': 'x-www-form-urlencoded',
      }, requestHeaders);

      body = encodeQueryData(body);
    } else if(typeof body === 'object' && !CONTENT_AS_FORMDATA) {
      // Convert object to a JSON string
      body = JSON.stringify(body);
    }
  }

  console.log('REQUEST_DISPATCHED', endpoint);
  // Execute request - returns a Promise so we can chain subsequent actions to dispatch to the store
  return new Promise((resolve, reject) => {
    let address = api_host;

    if(method != 'GET' && endpoint && endpoint.length) {
      address = api_host + '?endpoint=' + endpoint;
    } else {
      address = api_host + '/' + endpoint;
    }

    return timeoutPromise(REQUEST_TIMEOUT, fetch(address, {
      method: method,
      headers: requestHeaders,
      body: method != 'GET' ? body : undefined
    })).then((response) => {
      console.log('API_RESPONSE', endpoint, response.status);

      // Reject an empty response with an error code
      if((response.status >= 400) && (!response._bodyText || response._bodyText.length === 0)) {
        console.log("API_EMPTY_ERROR", endpoint, headers, body);
        reject(response);
      }

      return response.json().then((responseJSON) => {
        // Transform the response into its JSON representation
        return {
          status: response.status,
          data: responseJSON
        }
      }, (error) => {
        if(response.status >= 200 && response.status < 300) {
          // No body, but still a successful request. Return success code
          return {
            status: response.status,
            data: null
          }
        }
      });
    })
    .then((data) => {
      resolve(data);
    }, (error) => {
      console.log('API_ERROR', endpoint, headers, body);
      reject(error);
    });
  });
}

/*
  Assist creation of GET queries
 */
function encodeQueryData(data) {
  var ret = [];
  for (var d in data) {
    ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
  }

  return ret.join("&");
}

/*
  Fetch wrapper to handle timeouts
 */
function timeoutPromise(ms, promise) {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error("promise timeout"))
    }, ms);
    promise.then(
      (res) => {
        clearTimeout(timeoutId);
        resolve(res);
      },
      (err) => {
        clearTimeout(timeoutId);
        reject(err);
      }
    );
  })
}



// WEBPACK FOOTER //
// ./src/utils/Api/index.js